const baseURL = process.env.GATSBY_API_URL;
const headers = {
  ApiKey: process.env.GATSBY_API_KEY,
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
};

export default {
  get: async (path, { controller } = {}) => {
    const response = await fetch(baseURL + path, {
      headers,
      signal: controller?.signal,
    });
    const data = await response.json();
    return data;
  },
  post: async (path, body) => {
    const response = await fetch(baseURL + path, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });

    const data = await response.json();
    return data;
  },
};
